import { ENDPOINTS } from "./endpoints";
import HttpClient from "./HttpClient";

import { ProductFruitsUserInfo } from "types/entities/ProductFruits";
import { ResponseEnvelope } from "types/responses";

export const fetchUserInfo = async (): Promise<ResponseEnvelope<ProductFruitsUserInfo>> => {
  const res = await HttpClient.get(ENDPOINTS.productFruits.userInfo);

  return res.data;
};
